import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import { LinkCheckerProvider } from '../services/LinkChecker'

import './LayoutBase.scss'
import 'sanitize.css'
import 'github-markdown-css'
import 'typeface-inter'
import 'typeface-work-sans'

const LayoutBase = ({ children }) => {
  const meta = useStaticQuery(QUERY).site.siteMetadata

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name='description' content={meta.description} />
        <meta property='og:description' content={meta.description} />
        <meta property='og:site_name' content='Mashup Garage' />
        <meta name='twitter:image' content='summary_large_image' />
        <html lang='en' />
      </Helmet>

      <LinkCheckerProvider>{children}</LinkCheckerProvider>
    </>
  )
}

const QUERY = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default LayoutBase
